module.exports = __webpack_public_path__ + "img/volunteers_hero_image_svg.8b0d6d5.svg";